import { render, staticRenderFns } from "./PotentialPolicy.vue?vue&type=template&id=2ffa3124&"
import script from "./PotentialPolicy.vue?vue&type=script&lang=js&"
export * from "./PotentialPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports